import {faXmark} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import * as Dialog from "@radix-ui/react-dialog";

import {useEffect, useState} from "react";

import {useNavigate} from "react-router-dom";
import {useMediaQuery} from "@uidotdev/usehooks";

import {LeadTabs} from "./Tabs";
import {MobileView} from "./MobileView";

export const ManageLeads = () => {
    const navigate = useNavigate();
    const isSmallScreen = useMediaQuery("(max-width: 640px)");

    useEffect(() => {
        if (!isSmallScreen) {
            navigate("/");
        }
    }, [isSmallScreen, navigate]);

    return <MobileView/>;
};

export const LeadsDialog = () => {
    const [search, setSearch] = useState("");

    return (
        <Dialog.Portal>
            <Dialog.Overlay
                id="dialog"
                className="bg-gray-800 bg-opacity-60 fixed inset-0 z-40"
            />
            <Dialog.Content
                style={{transform: "translate(-50%, -50%)"}}
                className="fixed left-1/2 top-1/2 bg-white p-6 z-40 min-w-[87rem]"
            >
                <div className="flex justify-between items-center">
                    <Dialog.Title className="text-xl font-semibold text-gray-900">
                        Manage Leads
                    </Dialog.Title>

                    <Dialog.Close>
                        <div className="h-10 w-10">
                            <FontAwesomeIcon icon={faXmark}/>
                        </div>
                    </Dialog.Close>
                </div>

                <div className="max-h-[80vh] overflow-auto">
                    <LeadTabs search={search} setSearch={setSearch}/>
                </div>
            </Dialog.Content>
        </Dialog.Portal>
    );
};
